var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
let ListTextNodeInput = class ListTextNodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.listItems = [];
    }
    updated(changedProperties) {
        if (changedProperties.has("input") && this.input?.value) {
            this.syncListItems();
        }
    }
    syncListItems() {
        const value = this.input?.value || [];
        this.listItems = value.map((item) => ({ value: item }));
        this.requestUpdate();
    }
    onValueChange(index, event) {
        event.stopPropagation();
        const newValue = event.detail.input.value;
        this.listItems = this.listItems.map((item, i) => i === index ? { ...item, value: newValue } : item);
        this.requestUpdate();
        this.onInputChange();
    }
    addListItem() {
        this.listItems = [...this.listItems, { value: "" }];
        this.requestUpdate();
        this.onInputChange();
    }
    removeListItem(index) {
        this.listItems = this.listItems.filter((_, i) => i !== index);
        this.requestUpdate();
        this.onInputChange();
    }
    onInputChange() {
        const values = this.listItems.map((item) => item.value);
        this.input.value = values;
        this.dispatchEvent(new CustomEvent("node-input-change", {
            detail: {
                key: this.key,
                input: this.input
            },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <div class="list-node-input">
        ${this.listItems.map((item, index) => html `
            <div class="list-item">
              <text-node-input
                .input=${{ value: item.value, placeholder: msg('Value', { id: 'nodeInput.placeholder.value', desc: 'Value placeholder for list/key-value input' }) }}
                @node-input-change=${(e) => this.onValueChange(index, e)}
              ></text-node-input>
              <simple-button
                label="${CommonActions.remove()}"
                variant="danger"
                size="small"
                @button-click=${() => this.removeListItem(index)}
              ></simple-button>
            </div>
          `)}
        <simple-button
          label="${msg('Add Item', { id: 'nodeInput.action.addItem', desc: 'Add item button' })}"
          variant="success"
          size="small"
          @button-click=${this.addListItem}
        ></simple-button>
      </div>
    `;
    }
};
ListTextNodeInput.styles = css `
    .list-node-input {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .list-item {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    text-node-input {
      flex: 1;
    }
  `;
__decorate([
    property({ type: String })
], ListTextNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], ListTextNodeInput.prototype, "input", void 0);
__decorate([
    state()
], ListTextNodeInput.prototype, "listItems", void 0);
ListTextNodeInput = __decorate([
    localized(),
    customElement("list-text-node-input")
], ListTextNodeInput);
export { ListTextNodeInput };
//# sourceMappingURL=ListTextNodeInput.js.map